import { handleFormError } from 'assets/js/misc';

angular.module('logbook')
.directive('shiftRoleEditor', ['$timeout', "$http", "$location", "$window", "$q",
function($timeout, $http, $location, $window, $q) {
  return {
    restrict: 'E',

    scope: {
       selectedLog: '='
    },

	template: require('./shift-role-editor.html'),

    link: function(scope, elem, attrs) {
       scope.showTurnoverHelp = {};
       
       scope.resetAckOpts = function()
       {
          scope.ackOpts = [
             {"val": true, "label": "All Notes"},
             {"val": false, "label": "Turnover Notes"}
          ];
       };
       
       scope.resetAckOpts();
       
       scope.getAckOptDisplayName = function(role)
       {
          if(role.mustAckNotesMatchingReport)
             return 'Notes Matching Report: ' + role.mustAckNotesMatchingReport.name;
          else if(role.mustAckAllNotes)
             return 'All Notes';
          else
             return 'Turnover Notes';
       }
       
       scope.refreshRoles = function()
       {
          $http.get('/api/shiftRoles', {
             params: {
                'log': scope.selectedLog.id
             }
          }).then(function(results) {
             scope.shiftRoles = results.data._embedded.shiftRoles;
             scope.shiftRoles.forEach(function(role) {
                if( role.mustAckNotesMatchingReport )
                   role.mustAckAllNotes = role.mustAckNotesMatchingReport.complexObject._links.self.href;
                else
                   role.mustAckAllNotes = role.mustAckAllNotes || false;
             });
          });
       };
       scope.refreshRoles();
       
       scope.updateShiftRoleField = function(role, field, data)
       {
          var update = {};
          if( field == 'mustAckAllNotes')
          {
             if( data !== true && data !== false ) 
                update['mustAckNotesMatchingReport'] = data;
             else
             {
                update[field] = data;
                update['mustAckNotesMatchingReport'] = null;
             }
          }
          else
             update[field] = data;
          $http.patch(role._links.self.href, update)
          .then(function() {
             scope.refreshRoles();
          });
       };
       
       scope.resetNewRole = function() {
          scope.newRole = {
                'log' : scope.selectedLog._links.self.href
          };
       };
       
       scope.setNewRoleField = function(field, $data) {
          scope.newRole[field] = $data;
       };       
       scope.addRole = function()
       {
          var d = $q.defer();
          var newRole = angular.extend({}, scope.newRole);
          if( newRole.mustAckAllNotes !== true && newRole.mustAckAllNotes !== false )
          {
             newRole.mustAckNotesMatchingReport = newRole.mustAckAllNotes;
             delete newRole.mustAckAllNotes;
          }
          $http.post('/api/shiftRoles', newRole, {
             'noErrorPopup' : true,
             'rawError' : true
          }).then(function() {
             d.resolve();
             scope.refreshRoles();
          }, function(errors) {
             handleFormError(d, scope.newRoleForm, errors);
          });
          return d.promise;
       };
       
       scope.turnoverHelpText = '<div class="well">During shift sign-on, require '
          +'the acknowledgement of all notes in the log within this number of '
          + 'hours of signing onto shift before allowing new log entries to be made. '
          + 'Choose to require acknowledgement of all notes, only of turnover notes, '
          + 'or notes matching a report\'s criteria.'
          + "</div>";
       
       scope.deleteRole = function(role)
       {
          $http.delete(role._links.self.href).then(scope.refreshRoles);
       }
       
       scope.loadReportList = function()
       {
          return $http.get('/api/reports', {
             params: {
                'log': scope.selectedLog.id,
                'sort': 'name,asc',
                'activeRevision': true,
                'saveInProgress': false,
                'myReports': true,
                'templateTrigger': false
             }
          }).then(function(results) {
             scope.resetAckOpts();
             results.data._embedded.reports.forEach(report => {
                scope.ackOpts.push({"val": report.complexObject._links.self.href, "label": "Matching Report: " + report.name});
             })
          });
       };
       
    }
  }
}]);
